import { IconContentHighlight } from '@doltech/icons/IconContentHighlight';
import { IconSystemV2ContentDehighlight } from '@doltech/icons/SystemV2/IconSystemV2ContentDehighlight';
import { IconSystemV2ContentPenContent } from '@doltech/icons/SystemV2/IconSystemV2ContentPenContent';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { insertNote } from '@doltech/ui/lib/figma/DolEditor/elements/note/transform/insertNoteAtSelection';
import { isMarkActive } from '@doltech/ui/lib/figma/DolEditor/helpers';
import { Tooltip } from 'antd';
import dynamic from 'next/dynamic';
import * as React from 'react';
import { Editor, Transforms } from 'slate';
import { useSlate } from 'slate-react';
import styled from 'styled-components';

const Toolbar = dynamic<any>(
  () =>
    import('@doltech/ui/lib/figma/DolEditor/toolbars/BalloonToolbar').then(
      (mod: any) => mod.DolBalloonToolbar.OnExpanded
    ),
  {
    ssr: false,
  }
);

interface ToolbarDoingTestProps extends React.HTMLAttributes<HTMLDivElement> {
  fontSizeMode?: string;
  setFontSizeMode?: any;
}

const BUTTONS = [
  {
    id: 1,
    format: 'highlight',
    Icon: IconContentHighlight,
  },
  {
    id: 2,
    format: 'deHighlight',
    Icon: IconSystemV2ContentDehighlight,
  },
  {
    id: 3,
    format: 'note',
    Icon: IconSystemV2ContentPenContent,
  },
];

const Main = styled.div`
  border: 1px solid ${colorsV2.black10};
  box-sizing: border-box;
  box-shadow: 0 10px 20px ${colorsV2.blackShadow4}, 0 2px 6px ${colorsV2.blackShadow4},
    0 0 1px ${colorsV2.blackShadow4};
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: center;

  .list {
    display: flex;
    .list-item {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24px;
      flex: 1;
      height: 38px;
      width: 36px;
      cursor: pointer;
      color: ${colorsV2.black100};
      &:hover {
        background: linear-gradient(to bottom, #f6f6f6 5%, #fff 100%);
        background-color: #f6f6f6;
      }
      &.active {
        background: linear-gradient(to bottom, #e9e9e9 5%, #f9f9f9 100%);
        background-color: #e9e9e9;
      }
    }
  }
`;

export const ToolbarDoingTest = (props: ToolbarDoingTestProps) => {
  const editor = useSlate();

  return (
    <Toolbar theme="light" className="toolbar-wrapper do-test-toolbar">
      <Main className="toolbar" {...props}>
        <div className="list">
          {BUTTONS.map((button) => {
            const { id, Icon, format } = button;
            switch (format) {
              case 'note':
                return (
                  <Tooltip title="Note">
                    <div
                      tabIndex={0}
                      role="button"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        insertNote(editor);
                        Transforms.collapse(editor, { edge: 'end' });
                      }}
                      key={id}
                      className="list-item"
                    >
                      <Icon />
                    </div>
                  </Tooltip>
                );
              case 'highlight':
                return (
                  <Tooltip title="Highlight">
                    <div
                      tabIndex={0}
                      role="button"
                      onMouseDown={(e) => {
                        e.preventDefault();
                        Editor.addMark(editor, format, true);
                        Transforms.collapse(editor, { edge: 'end' });
                      }}
                      key={id}
                      className="list-item"
                    >
                      <Icon />
                    </div>
                  </Tooltip>
                );
              case 'deHighlight':
                if (isMarkActive(editor as any, 'highlight')) {
                  return (
                    <Tooltip title="Remove highlight">
                      <div
                        tabIndex={0}
                        role="button"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          Editor.removeMark(editor, 'highlight');
                          Transforms.collapse(editor, { edge: 'end' });
                        }}
                        key={id}
                        className="list-item"
                      >
                        <Icon />
                      </div>
                    </Tooltip>
                  );
                }
                break;
              default:
                return null;
            }
            return null;
          })}
        </div>
      </Main>
    </Toolbar>
  );
};
